import React, { Component } from "react";
import WordList from "./WordList";
//import Notifications from './Notifications'
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import EnhancedTable from "./EnhancedTable";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { bookmarkWords } from "../../store/actions/wordAction";
import { deleteWords } from "../../store/actions/wordAction";

import { changeSets } from "../../store/actions/wordAction";
import { changeDates } from "../../store/actions/wordAction";
import { changeLevels } from "../../store/actions/wordAction";
//import { SpeakText } from './Speak'
//import { LoadSpeak } from './Speak'

import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import IconButton from "@material-ui/core/IconButton";
import PlayIcon from "@material-ui/icons/PlayCircleFilled";
import Paper from "@material-ui/core/Paper";
import Play from "./Play";

import SwipeableTemporaryDrawer from "../shared/SwipeableTemporaryDrawer";

import { getFirestore } from "redux-firestore";
import { Container } from "@material-ui/core";
import exportFromJSON from "export-from-json";

var filter = false;
var set_g = "";
var selected_items;

class Dashboard extends Component {
  state = {
    words: [],
    setting: [{ id: "3", voice1: "3", voice2: "3" }],
    sets: [{ id: "3", name: "3" }],
    set_name: "",
    collection_name: "word_set",
    name: "",
    limit: 100,
    document_name: "",
  };

  handleEditRedirect = (id) => {
    let index = this.state.words.findIndex((e) => e.id == id);
    // alert("redireczt"+id);
    //   alert("redireczt"+index);
    this.props.history.push("/edit", {
      id: this.state.words[index].id,
      Language1: this.state.words[index].Language1,
      Language2: this.state.words[index].Language2,
      Language3: this.state.words[index].Language3,
      Language4: this.state.words[index].Language4,
      Description1: this.state.words[index].Description1,
      Description2: this.state.words[index].Description2,
      Description3: this.state.words[index].Description3,
      Description4: this.state.words[index].Description4,
      set: this.state.words[index].set,
      sets: this.state.sets,
    });
  };

  handleBookmarkFilter = (onoff) => {
    // alert("redifilter");
    // const newTasks = this.state.OriginalTasks.filter(el => el[key].toLowerCase().indexOf(query.toLowerCase()) > -1);
    if (onoff) {
      const filteredWords = this.state.original_words.filter(
        (el) => el["bookmarked"] == true
      );
      this.setState({
        words: filteredWords,
      });
    } else {
      this.setState({
        words: this.state.original_words,
      });
    }
  };

  handleChangeDate;
  handleChangeDate = (id) => {
    var selected_items = [];
    selected_items[0] = id;
    console.log(id);
    this.props.changeDates(selected_items, this.state.collection_name);
  };
  handleBookmarkItems = (selected, selected_option) => {
    // alert(selected);
    // alert(selected_option);
    let value = false;
    this.props.bookmarkWords(
      selected,
      selected_option,
      this.state.collection_name
    );
  };
  handleDeleteItems = (selected) => {
    alert(selected);
    // alert(selected_option);
    let value = false;
    this.props.deleteWords(selected, this.state.collection_name);
  };

  handleSelectedItemsChanged = (selected) => {
    selected_items = selected;
  };

  handleChangeSet = (name) => {
    this.props.changeSets(selected_items, name);
  };
  handleExportEXCEL = () => {
    const data = [
      {
        english: "english",
        german: "german",
        spanish: "spanish",
        french: "french",
        italian: "italian",
      },
    ];
    this.state.words.map((word) => {
      data.push({
        english: word.Language3,
        german: word.Language2,
        spanish: word.Language1,
        french: word.Language4,
        italian: word.Language5,
      });
    });
    const fileName = "download";
    // const exportType = "csv";
    const exportType = "xls";
    console.log(data);
    exportFromJSON({ data, fileName, exportType });
  };

  handleChangeLevel = (name, collection) => {
    alert(collection);
    this.props.changeLevels(selected_items, name, collection);
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      //words: nextProps.words,
      //original_words: nextProps.words,
      sets: nextProps.sets,
    });
    //mario
    //  LoadSpeak();
    //  console.log(this.setState.words);
  }

  componentWillMount() {
    this.fetchMainData(this.state.limit, "word_set");
  }

  //show only records that start with letter b
  // .orderBy("Language1", "desc")
  // .where("Language1","<","j")
  // .where("Language1",">","i")

  fetchMainData(limit, collection) {
    let single_document = {};
    const data = [];
    let firestore = getFirestore();
    firestore
      .collection(collection)
      //  .where("set","==","")
      //       .orderBy("Language1", "desc")
      // .where("Language1","<","j")
      // .where("Language1",">","g")
      .orderBy("createdAt", "desc")
      //.limit(3)
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          single_document = doc.data();
          single_document.id = doc.id;
          data.push(single_document);
        });
        this.setState({
          words: data,
          original_words: data,
        });
      });
  }

  RefreshFromDatabase = () => {
    if (this.state.name == "") {
      this.fetchMainData(5, "word_set");
    } else {
      this.handleSetFilter(
        this.state.name,
        this.state.limit,
        this.state.collection_name,
        this.state.document_name
      );
    }
  };

  handleSetFilter = (name, limit, collection, document_name) => {
    alert(limit);
    this.setState({
      name: name,
      limit: limit,
      collection_name: collection,
      document_name: document_name,
    });
    if (collection == undefined || collection == "") {
      collection = "word_set";
    }
    let equality;
    let param1;
    let param2 = name;
    if (name == "All") {
      equality = ">=";
      param1 = "set";
      this.fetchMainData(limit, collection);
      return;
    } else if (name == "Bookmarked") {
      equality = "==";
      param1 = "bookmarked";
      param2 = true;
    } else {
      equality = "==";
      //   param1 = "set";
      param1 = document_name;
    }
    //alert(document_name);

    this.filterBySet(param1, equality, param2, limit, collection);
  };

  filterBySet(param1, equality, param2, limit, collection) {
    let single_document = {};
    const data = [];
    let firestore = getFirestore();
    firestore
      .collection(collection)
      .where(param1, equality, param2)
      //.orderBy("createdAt", "desc")
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        //  firestore.collection("word_set").where("bookmarked","!=", true).orderBy("createdAt", "desc").limit(limit).get().then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          single_document = doc.data();
          single_document.id = doc.id;
          data.push(single_document);
        });
        // data = data.sort((a, b) => a.createdAt > b.createdAt);
        this.setState({
          words: data,
          original_words: data,
        });
        console.log(data);
      });
  }

  render() {
    return (
      <div className="margin1em">
        <Paper>
          {/* <WordList words={words}/> */}

          <EnhancedTable
            words={this.state.words}
            RedirectEdit={this.handleEditRedirect}
            BookmarkFilter={this.handleBookmarkFilter}
            BookmarkItems={this.handleBookmarkItems}
            DeleteItems={this.handleDeleteItems}
            handleSelectedItemsChanged={this.handleSelectedItemsChanged}
            sets={this.state.sets}
            collection_name={this.state.collection_name}
            ChangeDate={this.handleChangeDate}
            RefreshFromDatabase={this.RefreshFromDatabase}
          ></EnhancedTable>

          {/* <Play words={this.state.words}></Play> */}
          <SwipeableTemporaryDrawer
            handleChangeSet={this.handleChangeSet}
            handleChangeLevel={this.handleChangeLevel}
            sets={this.state.sets}
            handleSetFilter={this.handleSetFilter}
            handleExportEXCEL={this.handleExportEXCEL}
          ></SwipeableTemporaryDrawer>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //  console.log(state.firestore);
  //console.log(this.state.words);
  return {
    //  words: state.firestore.ordered.word_set,
    settings: state.firestore.ordered.settings,
    sets: state.firestore.ordered.sets,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    bookmarkWords: (selected, value, collection) =>
      dispatch(bookmarkWords(selected, value, collection)),
    deleteWords: (selected, collection) =>
      dispatch(deleteWords(selected, collection)),
    changeSets: (selected, value) => dispatch(changeSets(selected, value)),
    changeLevels: (selected, value, collection) =>
      dispatch(changeLevels(selected, value, collection)),
    changeDates: (selected, collection) =>
      dispatch(changeDates(selected, collection)),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect([
    //      {
    //   //    collection: 'word_set',
    //   //    orderBy: [['createdAt','desc']],
    //  //     limit:5
    //       // where: [
    //       //   ["set", "==", set_g]
    //       // ]
    //      },
    {
      collection: "settings",
    },
    {
      collection: "sets",
      orderBy: [["name", "asc"]],
    },
  ])
)(Dashboard);

// return [
//   {
//     collection: 'categories',
//     where: [
//       ['uid', '==', props.uid]
//,
//     orderBy: [['Language1','asc']]
//     ]
//   }
// ]
